import script from "./IntroSection.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroSection.vue?vue&type=script&setup=true&lang=js"

import "./IntroSection.vue?vue&type=style&index=0&id=89c8962e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89c8962e"]])

export default __exports__